import * as yup from 'yup';
export const validateEpicAccountSchema = yup.object({
    accountCode: yup.string().trim().required(),
    postalCode: yup.string().trim().required(),
    phoneNumber: yup.string().trim().required(),
    overrideCcFee: yup.number().integer().nullable(),
    overrideAchFee: yup.number().integer().nullable(),
    overrideEftFee: yup.number().integer().nullable(),
});
export const lookupInvoiceNumberSchema = yup.object({
    accountCode: yup.string().trim().required(),
    invoiceNumber: yup.string().trim().required(),
    postalCode: yup.string().trim().required(),
    firstName: yup.string().trim().required(),
    lastName: yup.string().trim().required(),
    userEmail: yup.string().email().trim().required(),
});
export const AgencyFeeClassCodes = ['FEES'];
export const NonAgencyFeeClassCodes = ['FEAC', 'GFEE'];
export const FeeClassCodes = AgencyFeeClassCodes.concat(NonAgencyFeeClassCodes);
export const TaxClassCodes = ['TXAC', 'GCTX', 'GTAC', 'GTAX'];
export const PremiumClassCodes = ['ACUR'];
export const NonFinanceableCodes = ['AUDI'];
export var EpicBusinessTypes;
(function (EpicBusinessTypes) {
    EpicBusinessTypes["AGRICULTURE"] = "AGRICULTURE";
    EpicBusinessTypes["BENEFITS"] = "BENEFITS";
    EpicBusinessTypes["BONDS"] = "BONDS";
    EpicBusinessTypes["COMMERCIAL"] = "COMMERCIAL";
    EpicBusinessTypes["FINANCIAL_SERVICES"] = "FINANCIAL_SERVICES";
    EpicBusinessTypes["LIFE_AND_HEALTH"] = "LIFE_AND_HEALTH";
    EpicBusinessTypes["OTHER"] = "OTHER";
    EpicBusinessTypes["PERSONAL"] = "PERSONAL";
})(EpicBusinessTypes || (EpicBusinessTypes = {}));
export const epicTransactionSchema = yup.object({
    id: yup.string().required(),
    amount: yup
        .object({
        units: yup.number().integer().required(),
        partialUnits: yup.number().integer().required(),
    })
        .defined(),
});
export const epicInvoiceSchema = yup.object({
    invoiceNumber: yup.string().required(),
    dueDate: yup.string().required(),
    amountDue: yup.string().required(),
    amountDueMinorUnits: yup.number().required(),
});
export const applyPaymentInEpicSchema = yup.object({
    paymentId: yup.number().required(),
    epicProduct: yup.string().default('Epic').optional(),
    epicClientId: yup.string().required(),
    epicAccountNumber: yup.string().required(),
    target: yup.mixed().oneOf(['account', 'invoice']).defined(),
    agencyId: yup.string().when('target', {
        is: 'account',
        then: (s) => s.required(),
    }),
    branchId: yup.string().when('target', {
        is: 'account',
        then: (s) => s.required(),
    }),
    epicTransactions: yup
        .array()
        .of(epicTransactionSchema.defined())
        .when('target', {
        is: 'invoice',
        then: (s) => s.required(),
    }),
    epicInvoices: yup
        .array()
        .of(epicInvoiceSchema.defined())
        .when('target', {
        is: 'invoice',
        then: (s) => s.required(),
    }),
});
export const epicSubResponseSchema = yup.object({
    referenceId: yup.string().required(),
    responseType: yup.mixed().required().oneOf(['PAYMENT', 'REFUND', 'LOCKBOX']),
    status: yup.mixed().required().oneOf(['COMPLETED', 'FAILED']),
});
//# sourceMappingURL=epicLookups.js.map